import { BASE_STORE_INITIAL_STATE } from './chunk-7PCIVIEC.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/state/menu/initialStates/modifierGroups_initialState.ts
var MODIFIER_GROUP_PRICING_VERSION_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  name: "Default",
  organizationId: 0,
  locationId: 0,
  modifierGroupId: 0,
  modItemPricingVersions: {},
  createdByLocationId: null,
  modifierGroupPricingVersionId: 1,
  locationModifierGroupPricingVersionId: 0,
  locationModifierGroupPricingVersionVersionId: 0
});
var MODIFIER_GROUPS_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  activeCustomizerSectionSelector: false,
  locationModifierGroupId: 0,
  locationModifierGroupVersionId: 0,
  locationId: null,
  createdByLocationId: 0,
  organizationId: 0,
  modifierGroupId: 0,
  name: "",
  posName: "",
  kdsName: "",
  checkName: "",
  active: true,
  description: "",
  multiselect: true,
  quantityMode: "x1,x2,x3" /* NUMBER */,
  requiredModifierItems: 0,
  includedModifierItems: 0,
  maximumModifierItems: 0,
  allowNoneSelection: false,
  defaultModifierGroupPricingVersionId: 1,
  modifierItems: {},
  showSearchBar: false,
  searchAllModifierItems: false,
  modifierGroupPricingVersions: {
    1: MODIFIER_GROUP_PRICING_VERSION_INITIAL_STATE
  },
  itemIds: {},
  onlineName: "",
  parentModifierItemIds: [],
  priceCalcMode: "max",
  hidePriceIfFree: false,
  showModGroupTitleOnRegisterTicket: false,
  showModGroupTitleOnKitchenTicket: false,
  guestCheck: false,
  defaultSelectionPrice: 0,
  backgroundColor: null,
  textColor: null,
  enableModTags: true,
  enableQuantityBar: false,
  customizerSlicing: "quarters" /* QUARTERS */
});

export { MODIFIER_GROUPS_INITIAL_STATE, MODIFIER_GROUP_PRICING_VERSION_INITIAL_STATE };
